import { getDifferenceBetweenFirstAndLastValues, getFirstAndLastValues, getsumOfValues } from "@/utils/analytics/growthMetricsUtils"

export const youtubeFollowersGrowthConfig = [
    {
        plotName: "subscribers",
        metricName: "subscribers",
        sumMetrics: false,
        title: "analytics_growth.subscribers",
        helpText: "analytics_growth.total_number_of_followers_across_platforms",
        cssIcon: "fa-duotone fa-solid fa-users",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getFirstAndLastValues,
    },
    {
        plotName: "subscribers",
        metricName: "subscribers",
        sumMetrics: false,
        title: "analytics_growth.new_subscribers",
        helpText: "analytics_growth.users_who_followed_you_recently",
        cssIcon: "fa-duotone fa-solid fa-user-plus",
        cssIconColor: "#7239EA",
        showGrowthBadge: false,
        calculateFunction: getDifferenceBetweenFirstAndLastValues,
    },
]

export const youtubePlatformsInteractionsConfig = [


    {
        plotName: "interactions",
        metricName: "comments",
        sumMetrics: false,
        title: "analytics_growth.comments",
        helpText: "analytics_growth.total_number_of_comments_youtube",
        cssIcon: "fa-duotone fa-solid fa-comments",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "interactions",
        metricName: "likes",
        sumMetrics: false,
        title: "analytics_growth.likes",
        helpText: "analytics_growth.total_number_of_likes_youtube",
        cssIcon: "fa-duotone fa-solid fa-thumbs-up",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "interactions",
        metricName: "dislikes",
        sumMetrics: false,
        title: "analytics_growth.dislikes",
        helpText: "analytics_growth.total_number_of_dislikes_youtube",
        cssIcon: "fa-duotone fa-solid fa-thumbs-down",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    }
]


export const youtubePlatformsGrowthConfig = [


    {
        plotName: "profile_analytics",
        metricName: "profile_views",
        sumMetrics: false,
        title: "analytics_growth.profile_views",
        helpText: "analytics_growth.total_number_of_profile_views_youtube",
        cssIcon: "fa-duotone fa-solid fa-eye",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "profile_analytics",
        metricName: "videos_uploaded",
        sumMetrics: false,
        title: "analytics_growth.videos_uploaded",
        helpText: "analytics_growth.total_number_of_videos_uploaded_youtube",
        cssIcon: "fa-duotone fa-solid fa-video",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getsumOfValues,
    },
    {
        plotName: "profile_analytics",
        metricName: "videos_count",
        sumMetrics: false,
        title: "analytics_growth.videos_count",
        helpText: "analytics_growth.total_number_of_videos_count_youtube",
        cssIcon: "fa-duotone fa-solid fa-video",
        cssIconColor: "#7239EA",
        showGrowthBadge: true,
        calculateFunction: getFirstAndLastValues,
    }
]
